import isNil from 'lodash/isNil';

export function replaceWhiteSpaceToUnderbar(str?: string) {
  if (isNil(str)) {
    return str;
  }

  return str.replace(/(\s)/g, '_');
}
